import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'Main',
    isTitle: true
  },
  {
    label: 'Dashboard',
    icon: 'pie-chart',
    link: '/dashboard'
  }
  // ,
  // {
  //   label: 'Strategies',
  //   isTitle: true
  // },
  // {
  //   label: 'Short Straddle',
  //   icon: 'triangle',
  //   link: '/strategies/short-straddle'
  // },
  // {
  //   label: 'Stoploss/Breakout',
  //   icon: 'activity',
  //   link: '/strategies/stoploss-hunt',
  // },
  // {
  //   label: 'Trend Stocks',
  //   icon: 'list',
  //   link: '/strategies/trend-stocks',
  // },
  // {
  //   label: 'BankNifty Index',
  //   icon: 'percent',
  //   link: '/strategies/trend-index',
  // }

];
